import {AutocompleteProps} from '@/components/basic/Autocomplete2';
import AutocompleteInput, {AutocompleteInputProps} from '@/components/refinedev/AutocompleteInput';
import {ChoiceProps} from '@/hooks/types';

export const ProjectAutocompleteInput = (
  props: Pick<AutocompleteInputProps, 'source'> &
    Partial<AutocompleteInputProps> &
    Pick<AutocompleteProps, 'EmptyValue'>,
) => {
  const {EmptyValue = true} = props;
  return (
    <AutocompleteInput
      {...props}
      reference="projects"
      autoCompleteProps={{
        optionText: 'name',
        placeholder: 'Chọn dự án',
        placeholder_input: 'Tìm kiếm dự án',
        EmptyValue: EmptyValue,
        ...props.autoCompleteProps,
      }}
    />
  );
};
